import { makeStyles, tokens } from "@fluentui/react-components";

export const useCoachmarkStyles = makeStyles({
    teachingPopoverSurface: {
        maxWidth: "304px"
    },
    popoverBodyText: {
        color: tokens.colorNeutralForeground3
    }
});
